/** Lazy route modules warmed during offline download / app bootstrap when bundles exist. */

export const OFFLINE_SERVICE_ROUTE_IMPORTS = [
  () => import('@features/service/service.routes'),
  () => import('@features/service/pages/service-base-page/service-base-page.component'),
  () => import('@features/service/components/technicians-table/technicians-table.component'),
  () => import('@features/service/pages/technician-details-page/technician-details-page.component'),
  () => import('@features/service/pages/technician-details-page/technician-profile-section/technician-profile-section.component'),
  () => import('@features/service/pages/technician-details-page/technician-competencies-table/technician-competencies-table.component'),
  () => import('@features/service/pages/technician-details-page/technician-update-logs-table/technician-update-logs-table.component'),
  () => import('@features/service/pages/technician-details-page/technician-schedule-section/technician-schedule-section.component'),
  () => import('@features/service/pages/technician-details-page/technician-assigned-requests-table/technician-assigned-requests-table.component'),
  () => import('@features/service/pages/technician-details-page/technician-forms-table/technician-forms-table.component'),
  () => import('@features/service/pages/service-request-form-page/service-request-form-page.component'),
  () => import('@features/service/pages/service-request-form-page/service-request-form-content/service-request-form-content.component'),
  () => import('@features/service/pages/service-request-form-page/service-request-signature-pad/service-request-signature-pad.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-photo-slot/service-request-form-photo-slot.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-checklist-section/service-request-form-checklist-section.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-photo-preview/service-request-form-photo-preview.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-grouped-checklist-section/service-request-form-grouped-checklist-section.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-grid-section/service-request-form-grid-section.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-section/service-request-form-section.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-general-info-section/service-request-form-general-info-section.component'),
  () => import('@features/service/pages/service-request-form-page/components/shared/service-request-form-technician-signature-section/service-request-form-technician-signature-section.component'),
  () => import('@shared/components/breadcrumbs/breadcrumbs.component'),
  () => import('@features/service/pages/service-request-details-page/service-request-details-page.component'),
] as const;

/**
 * Static SVGs referenced by the service request form shell, banners, and checklist/photo UI.
 * `/assets/**` is lazy in ngsw — warm these during offline download so icons work without a prior visit.
 */
export const OFFLINE_SERVICE_FORM_ASSET_URLS: readonly string[] = [
  'assets/icons/back-black.svg',
  'assets/icons/right-arrow-black.svg',
  'assets/icons/chevron-left-blue.svg',
  'assets/icons/chevron-right-blue.svg',
  'assets/icons/plus-outline-blue.svg',
  'assets/icons/delete-darkgray.svg',
  'assets/icons/trash-blue.svg',
  'assets/icons/close-blue.svg',
  'assets/icons/form-photo-upload.svg',
  'assets/icons/form-photo-delete.svg',
  'assets/icons/form-checklist-image.svg',
  'assets/icons/form-checklist-notes.svg',
  'assets/icons/signature-delete-blue.svg',
  'assets/icons/signature-sign-blue.svg',
  'assets/icons/offline-mode-indicator.svg',
  'assets/icons/online-mode-indicator.svg',
];

/**
 * Matches hashed build assets listed in `ngsw.json` that must be in the SW cache
 * before the user can open downloaded routes offline without visiting them first.
 */
export const OFFLINE_SERVICE_SW_URL_PATTERNS: readonly RegExp[] = [
  /\/service\.routes-/,
  /\/service-base-page\.component-/,
  /\/technicians-table\.component-/,
  /\/service-request-form-page\.component-/,
  /\/service-request-form-content\.component-/,
  /\/service-request-signature-pad\.component-/,
  /\/service-request-details-page\.component-/,
  /\/technician-details-page\.component-/,
  /\/technician-forms-table\.component-/,
  /\/technician-profile-section\.component-/,
  /\/technician-competencies-table\.component-/,
  /\/technician-schedule-section\.component-/,
  /\/technician-assigned-requests-table\.component-/,
  /\/technician-update-logs-table\.component-/,
  /\/offline-save-sync-banner\.component-/,
  /\/offline-status-pill\.component-/,
  /\/breadcrumbs\.component-/,
  /\/service-request-form-photo-slot\.component-/,
  /\/service-request-form-checklist-section\.component-/,
  /\/service-request-form-photo-preview\.component-/,
  /\/service-request-form-grouped-checklist-section\.component-/,
  /\/service-request-form-grid-section\.component-/,
  /\/service-request-form-section\.component-/,
  /\/service-request-form-general-info-section\.component-/,
  /\/service-request-form-technician-signature-section\.component-/,
  /\/pp0[0-9]-form\.component-/,
  /\/pp24-form\.component-/,
  /\/pp-disp-form\.component-/,
  /\/pp-api-form\.component-/,
  /\/se06-form\.component-/,
];
